import { useEffect } from "react";
import ReactGA from "react-ga4";
import SignUpForm from "./sections/SignUpForm";
import { FooterSection, Header } from "./sections";
import { Player } from "@lottiefiles/react-lottie-player";

const SignUp = () => {
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "production") {
      ReactGA.initialize("G-ZB9N7T58NE");
      ReactGA.send({
        hitType: "pageview",
        page: "/signup",
        title: "Sign Up Page",
      });
    }
  }, []);
  return (
    <div className="relative min-h-screen min-w-full bg-black">
      <Header onlyLogo={true} />
      <div className="w-full min-h-[calc(100vh-80px)] flex flex-row overflow-auto mx-auto">
        <div className="w-[55%] flex flex-col justify-center items-center xs:w-full bg-black">
          <SignUpForm />
        </div>
        <div className="w-[45%] relative xs:hidden lg:flex flex-col justify-center items-center overflow-hidden">
          <div className="absolute -top-10 -right-10 w-80 h-56 opacity-40 bg-gradient-to-tr from-blue-700 via-indigo-800 to-blue-700 rounded-2xl blur-3xl" />
          <div className="mb-5 mx-auto  flex flex-col gap-6 items-center text-white">
            <div className="text-left flex justify-start w-full px-20 text-white/90 text-3xl font-semibold">
              AI-Driven Precision Estimates
            </div>
            <div className="text-left flex justify-start max-w-full px-20 text-gray-300 text-sm leading-relaxed">
              Say goodbye to the resource-draining task of sizing estimates.
              Cadencepro.ai accurately calculates key execution parameters,
              freeing your team to focus on strategy.
            </div>
           

            <div className="rounded-xl w-[80%] border border-light-border-subtle/20 bg-black/30 p-3  shadow-inner">
              <Player
                autoplay
                loop
                src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/lottieFilesJson/Estimate.json"
              />
            </div>
            <div className="flex justify-start w-full px-20 gap-2">
              <div className="px-2 py-2 rounded-lg border border-gray-500/40 text-center text-white text-xs font-bold uppercase">
                SWIFT ACCURACY
              </div>
              <div className="px-2 py-2 rounded-lg border border-gray-500/40 text-center text-white text-xs font-bold uppercase">
                DOMAIN KNOWLEDGE
              </div>
            </div>
          
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
};

export default SignUp;
